export const RewardsQueryKeys = {
  all: () => ["rewards"] as const,
  list: () => ["rewards", "list"] as const,
  detail: (id: string, periodStart: string | null) =>
    ["rewards", "detail", id, periodStart ?? ""] as const,
  announcements: () => ["rewards", "announcements"] as const,
};
